import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMConst from 'lib/SMConst';
import SMUserResource from 'resources/SMUserResource';

class SMUFavoriteDeleteView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      display: this.props.display,
      errorText: ""
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
    }
  }

  dismiss(e) {
    $(this.refs.modal).find(".md-close").click();
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.favoriteDeleteViewDidClose === 'function'){
        this.props.delegate.favoriteDeleteViewDidClose();
      }
    }
  }

  formDidSubmit(e) {
    e.preventDefault();
    const $messageContainer = $(this.refs.modal);
    let responseHandler = (data, error, xhr)=>{
      if(error) {
        if (xhr.responseJSON.message) {
          this.setState({errorText: xhr.responseJSON.message,});
        } else {
          $messageContainer.showFailMessage(I18n.t("dashboard.error_000001"));
        }
      } else {
        //親Component(お気に入り)のメソッドを呼び、お気に入り一覧を更新する。
        this.props.removeFavorite();
        this.dismiss();
      }
    };
    SMUserResource.deleteListedFavorite(this.props.user.username, this.props.favoriteList.id, this.props.room.id, "Room",responseHandler);
  }

  renderFormItemError() {
    const message = this.state.errorText;
    if (message) {
      return(
        <p className="dashboad-favorite__popup-form-error-cancel"><i className="fa fa-exclamation-circle mr3"></i>{message}</p>
      );
    }
    return null;
  }

  render() {
    return (
      <div>
        <div className="md-modal md-effect-101 md-width-800" ref="modal">
          <div className="md-content">
            <div className="page__popup dashboad-favorite__delete-favorite">
              <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
                <p className="page__popup__cancel dashboad-favorite__popup-cancel">
                  <a className="md-close" onClick={this.dismiss.bind(this)} href="#">
                    <span className="page__popup__cancel-icon dashboad-favorite__popup-cancel-icon">×</span>
                    <span className="dashboad-favorite__popup-cancel-text">キャンセル</span>
                  </a>
                </p>
                <div className="popup-headline">
                  <h1 className="popup-headline__title">お気に入りから削除</h1>
                  <p className="dashboad-favorite__popup-headline-text">お気に入りからスペースを削除します。<br className="pc-hide__sm-show" />削除してもよろしいですか？</p>
                </div>
                {this.renderFormItemError()}
                <input type="submit" name="commit" value="削除" className="button-blue dashboad-favorite__popup-content-button" />
              </form>
            </div>
          </div>
        </div>
        <div className="md-overlay"></div>
      </div>
    );
  }
}
SMUFavoriteDeleteView.defaultProps = {
  display: SMConst.Display.Visible
};
SMUFavoriteDeleteView.propTypes = {
  user: PropTypes.object.isRequired
};
export default SMUFavoriteDeleteView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUFavoriteDeleteView.jsx